<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table th>.cell {
    white-space: pre-wrap;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <el-tabs v-model="active" type="card" @tab-click="handleClick">
        <el-tab-pane name="declare">
          <template #label>
            <span><i class="el-icon-date"></i> 质量评价</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="queryform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <el-table-column prop="drugTypeFlagZx" label="分类" width="65" align='center'></el-table-column>
            <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="drugDosage" label="剂型" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="code" label="统编代码" width="135" align='center'></el-table-column>
            <el-table-column fixed="right" prop="score" label="质量分" width="65" align='right'></el-table-column>
            <!-- <el-table-column fixed="right" prop="offer" label="报价" width="80" align='center'>
              <template scope="scope">
                <el-input size="mini" v-model="scope.row.offer" placeholder="请输入报价" @change="checkOffer(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" prop="offer" label="日均用量" width="80" align='center'>
              <template scope="scope">
                <el-input size="mini" v-model="scope.row.goodsNum" placeholder="请输入日均用量" @change="checkOffer(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" prop="offer" label="日均金额" width="80" align='center'>
              <template scope="scope">
                <el-input size="mini" v-model="scope.row.goodsSum" placeholder="请输入日均用量" @change="checkOffer(scope.row)"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="120" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="queryform.pageNo"
            :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane name="bargain">
          <template #label>
            <span><i class="el-icon-connection"></i> 在线报价</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-form ref="bargainform" :model="bargainform" label-width="80px">
            <el-row>
              <el-col :span="19">
                <el-form-item label="">
                  <!-- <el-radio-group v-model="bargainform.status" @change="getProductPage">
                    <el-radio name="type" :label="8">已中选</el-radio>
                    <el-radio name="type" :label="7">可报价</el-radio>
                    <el-radio name="type" :label="4">已失效</el-radio>
                  </el-radio-group> -->
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="getProductPage" round>查&ensp;询</el-button>
                  <!-- <el-button type="primary" icon="el-icon-edit" size="mini" @click="" round v-if="btnActive[3]">继续报价</el-button> -->
                  <!-- <el-button type="primary" icon="el-icon-search" @click="getProductPage" size="small" round>查&emsp;询</el-button>&emsp;&emsp; -->
                  <!-- <el-badge :value="productOfferList.length" :max="99" class="item" v-if="btnActive[3]">
                    <el-button type="primary" icon="el-icon-edit" size="mini" @click="" round>继续报价</el-button>
                  </el-badge>&emsp; -->
                </el-form-item>
            </el-col>
            </el-row>
          </el-form>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="bargainform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center' rowspan=2></el-table-column>
            <el-table-column prop="code" label="统编代码" width="115" align='center'></el-table-column>
            <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="drugDosage" label="剂型" width="80" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="packageSpecific" label="包装规格" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="140" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="statusName" label="状态" width="65" align='center'></el-table-column>
            <!-- <el-table-column prop="winPrice" label="中选价格(元)" :formatter="thousandth" width="100" align='right' v-if="8 == bargainform.status"></el-table-column> -->
            <el-table-column align="center">
              <template slot="header">
                <div>议价填报（GPO）</div><div>降幅和GPO议价价格必填，有小数则保留两位。</div>
              </template>
              <el-table-column prop="discount" :label="'降幅(%)'" :formatter="thousandth" align='center' width="100">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.discount" :disabled="'true' === scope.row.disabled" style="width: 70px;" placeholder="请填写价格降幅" suffix-icon="iconfont icon-baifenbi"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="declarePrice" :label="'GPO议价(元)'" :formatter="thousandth" align='center' width="110">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.declarePrice" :disabled="'true' === scope.row.disabled" style="width: 80px;" placeholder="请填写议价价格"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="operator" :label="'操作'" width="70" align="center">
                <template slot-scope="scope">
                  <template v-if="'true' === scope.row.disabled">
                    <div style="font-size: 13px; cursor: pointer; color: #1890ff;" @click="scope.row.disabled = 'false'">
                      <i class="el-icon-edit" style="font-size: 16px; font-weight: 500;" title="填报"></i><span>填报</span>
                    </div>
                  </template>
                  <template v-if="'false' === scope.row.disabled">
                    <div style="font-size: 13px; cursor: pointer; color: #67C23A;" @click="submitDiscount(scope.row)">
                      <i class="el-icon-finished" style="font-size: 16px; font-weight: 500;" title="保存"></i><span>保存</span>
                    </div>
                  </template>
                </template>
              </el-table-column>
            </el-table-column>

            <!-- <el-table-column prop="discount" :label="'降幅(%)\n（示例：填写5.25，表示填报降幅为5.25%）'" :formatter="thousandth" align='center'>
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-tag plain v-if="scope.row.discount">{{ scope.row.discount }}</el-tag>&emsp;<i class="el-icon-edit" style="font-size: 16px; font-weight: 400; color: #1890ff; cursor: pointer;" title="修改" @click="scope.row.edit = false"></i>
                </template>
                <template v-else>
                  <el-input size="mini" v-model="scope.row.discount" style="width: 60px;" placeholder="请填写价格降幅" @blur="checkDiscount(scope.row)" slot="reference"></el-input>
                  <el-link type="primary" :underline="false" style="font-size: 11px;" @click="submitDiscount(scope.row)">&nbsp;&nbsp;提交</el-link>
                </template>
              </template>
            </el-table-column> -->
            <!-- <el-table-column fixed="right" prop="statusDesc" label="重新议价说明" width="150" align='center'></el-table-column> -->
            <!-- <el-table-column fixed="right" label="操作" width="120" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- <el-pagination @size-change="(val) => handlePagination(null, val, 'bargainform')" @current-change="(val) => handlePagination(val, null, 'bargainform')" @prev-click="(val) => handlePagination(val, null, 'bargainform')" @next-click="(val) => handlePagination(val, null, 'bargainform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="bargainform.pageNo"
            :page-sizes="bargainform.pageSizes" :page-size="bargainform.pageSize" :total="bargainform.total">
          </el-pagination> -->
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>

  <!-- 生产企业药品质量评价（西药 -> 自评） -->
  <el-dialog :title="product.drugInfo" :visible.sync="NXAssessFormVisible" width="1225px" top="50px" marginTop="5px" marginButton="5px">
    <el-form key="product" :model="product" :rules="productRules" ref="product">
      <el-collapse v-model="activeName">
        <el-collapse-item v-for="(outer, key) in xnItems" v-if="outer.name" :key="key" :disabled="outer.disabled">
          <template #title>
            <el-tooltip placement="right" effect="light"><div slot="content" v-html="xnSlot(key)" style="color: #999; font-size: 14px;line-height: 24px;"></div><el-tag effect="plain">{{outer.name}}（{{outer.score}}分）</el-tag></el-tooltip>
            <el-alert v-if="outer.info" :title="outer.info" type="info" show-icon :closable="false"></el-alert>
            <el-radio-group size="mini" v-model="product[key]" v-if="outer.disabled">
              <el-radio border v-for="(inner, idx) in product.configList" :key="idx" v-if="outer.disabled && (inner.stype + inner.skey).toLowerCase() == key" :label="inner.id" :disabled="0 == inner.scode" @click.native.prevent="handleRadioClick(inner, key)">
                  {{inner.remark}}{{0 == inner.scode ? '' : '（' + inner.svalue + '分）'}}
              </el-radio>
            </el-radio-group>
          </template>
          <el-radio-group size="mini" v-model="product[key]" v-if="!outer.disabled">
            <div v-for="inner in product.configList" v-if="!outer.disabled && (inner.stype + inner.skey).toLowerCase() == key" :class="inner.htmlClass">
              <el-radio border :label="inner.id" :disabled="0 == inner.scode" @click.native.prevent="handleRadioClick(inner, key)">
                {{inner.remark}}{{0 == inner.scode ? '' : '（' + inner.svalue + '分）'}}
              </el-radio>
            </div>
          </el-radio-group>
        </el-collapse-item>
        <el-collapse-item :disabled="!product['blackMark']" name="blackRecord">
          <template #title>
            <el-tooltip placement="right" effect="light"><div slot="content" style="color: #999; font-size: 14px;line-height: 24px;">主要针对在对申报药品的抽检中，发现存在严重质量安全风险，可能对身体健康和生命安全造成严重危害的质量不合格或召回的情况。</div><el-tag type="danger" effect="plain">不良记录（-30分）</el-tag></el-tooltip>
            <el-checkbox size="mini" v-model="product.blackMark" label="128" border
              @change="blackInputVisible=!blackInputVisible; activeName=(!product.blackMark?'':'blackRecord')">最近3年内在全国范围内，有省级及以上质量抽检不合格或召回</el-checkbox>
          </template>
          <el-input type="textarea" rows="2" placeholder="请说明澄清不良记录" v-model="product.blackRecord" clearable :disabled="!product['blackMark']" maxlength="200" show-word-limit></el-input>
        </el-collapse-item>
        <el-collapse-item disabled>
          <template #title>
            <el-tag type="info" effect="plain">备注/说明</el-tag>
            <el-input type="textarea" rows="1" placeholder="请输入备注/说明" v-model="product.remark" maxlength="200" show-word-limit style="width: 85%"></el-input>
          </template>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <!-- <el-button size="mini" @click="operator = -1; getByAssess()"><i class="el-icon-d-arrow-left"></i>&nbsp;上一个</el-button> -->
        <el-button size="mini" @click="NXAssessFormVisible = false">关&emsp;闭</el-button>
        <el-badge type="success" :value="product.score" :max="100" class="assess-score">
          <el-button size="mini" :loading="submitButtonLoading" type="primary" @click="submitForm('product')">提&emsp;交</el-button>
        </el-badge>
        <!-- <el-button size="mini" @click="operator = 1; getByAssess()">下一个&nbsp;<i class="el-icon-d-arrow-right"></i></el-button> -->
      </span>
    </template>
  </el-dialog>
  <!-- 生产企业药品质量评价（中成药 -> 自评） -->
  <el-dialog :title="product.drugInfo" :visible.sync="NZAssessFormVisible" width="1225px" top="50px" marginTop="5px" marginButton="5px">
    <el-form key="product" :model="product" :rules="productRules" ref="product">
      <el-collapse v-model="activeName">
        <el-collapse-item v-for="(outer, key) in znItems" v-if="outer.name" :key="key" :disabled="outer.disabled">
          <template #title>
            <el-tooltip placement="right" effect="light"><div slot="content" v-html="znSlot(key)" style="color: #999; font-size: 14px;line-height: 24px;"></div><el-tag effect="plain">{{outer.name}}（{{outer.score}}分）</el-tag></el-tooltip>
            <el-alert v-if="outer.info" :title="outer.info" type="info" show-icon :closable="false"></el-alert>
            <el-radio-group size="mini" v-model="product[key]" v-if="outer.disabled">
              <el-radio border v-for="(inner, idx) in product.configList" :key="idx" v-if="outer.disabled && (inner.stype + inner.skey).toLowerCase() == key" @click.native.prevent="handleRadioClick(inner, key)"
                :label="inner.id" :disabled="0 == inner.scode">
                  {{inner.remark}}{{0 == inner.scode ? '' : '（' + inner.svalue + '分）'}}
              </el-radio>
            </el-radio-group>
          </template>
          <el-radio-group size="mini" v-model="product[key]" v-if="!outer.disabled">
            <div v-for="(inner, idx) in product.configList" :key="idx" v-if="!outer.disabled && (inner.stype + inner.skey).toLowerCase() == key" :class="inner.htmlClass">
              <el-radio border :label="inner.id" :disabled="0 == inner.scode" @click.native.prevent="handleRadioClick(inner, key)">
                {{inner.remark}}{{0 == inner.scode ? '' : '（' + inner.svalue + '分）'}}
              </el-radio>
            </div>
          </el-radio-group>
        </el-collapse-item>
        <el-collapse-item :disabled="!product['blackMark']" name="blackRecord">
          <template #title>
            <el-tooltip placement="right" effect="light"><div slot="content" style="color: #999; font-size: 14px;line-height: 24px;">主要针对在对申报药品的抽检中，发现存在严重质量安全风险，可能对身体健康和生命安全造成严重危害的质量不合格或召回的情况。</div><el-tag type="danger" effect="plain">不良记录（-30分）</el-tag></el-tooltip>
            <el-checkbox size="mini" v-model="product.blackMark" label="128" border
              @change="blackInputVisible=!blackInputVisible; activeName=(!product.blackMark?'':'blackRecord')">最近3年内在全国范围内，有省级及以上质量抽检不合格或召回</el-checkbox>
          </template>
          <el-input type="textarea" rows="1" placeholder="请说明澄清不良记录" v-model="product.blackRecord" clearable :disabled="!product['blackMark']" maxlength="200" show-word-limit></el-input>
        </el-collapse-item>
        <el-collapse-item disabled>
          <template #title>
            <el-tag type="info" effect="plain">备注/说明</el-tag>
            <el-input type="textarea" rows="2" placeholder="请输入备注/说明" v-model="product.remark" style="width: 85%" maxlength="200" show-word-limit></el-input>
          </template>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <!-- <el-button size="mini" @click="operator = -1; getByAssess()"><i class="el-icon-d-arrow-left"></i>&nbsp;上一个</el-button> -->
        <el-button size="mini" @click="NZAssessFormVisible = false">关&emsp;闭</el-button>
        <el-badge type="success" :value="product.score" :max="100" class="assess-score">
          <el-button size="mini" :loading="submitButtonLoading" type="primary" @click="submitForm('product')">提&emsp;交</el-button>
        </el-badge>
        <!-- <el-button size="mini" @click="operator = 1; getByAssess()">下一个&nbsp;<i class="el-icon-d-arrow-right"></i></el-button> -->
      </span>
    </template>
  </el-dialog>

  <template slot="xn-slot" slot-scope="{ data }">
    {{xnItems[data].remark}}
  </template>

  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'mydeclare',
    data(){
      //字母大小写+数字+特殊符号
      //var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}');
      let pwdRegex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,20}');
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }else if(!pwdRegex.test(value)){
          callback(new Error('密码中必须包含大小写字母、数字'));
        }else{
          if (this.assessPwd.checkPass !== '') {
            this.$refs.assessPwd.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.assessPwd.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateValid = (rule, value, callback) => {
        if(0 > Number(value)) {
          callback(new Error('请输入大于0的数字（两位小数）'));
        }else{
          // if(this.ruleForm.checkPass !== ''){
          //   this.$refs.ruleForm.validateField('checkPass');
          // }
          callback();
        }
      };
      var validateRate = (rule, value, callback) => {
        if(0 >= Number(value)){
          callback(new Error('还款比例应大于0'));
        }else{
          callback();
        }
      };

      return {
        active: 'declare',
        height: 0,
        operate: false,
        operator: 0,
        changed: '',
        blackInputVisible: true,
        submitButtonLoading: false,
        dialogPasswordVisible: false,
        btnActive: [true, false, false, false, false, false, false, false],
        activeName: '',
        tabPosition: 'left',
        declareResult: null,
        captchaUrl: '',
        uploadImgUrl: '',
        offerUploadUrl: '',
        fileListOfferFile: [],
        fileListfddbrsqzsImg:[],
        bargainform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getProductPage', status: 5
        },
        bargainOnlineForm: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getBargainOnlinePage', stype: 'OFFERONLINE'
        },
        formRules: {
          payableSum: [
            { required: true, message: '请输入应付款金额', trigger: 'blur' },
            { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateValid, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          paymentSum: [
            { required: true, message: '请输入已付款金额', trigger: 'blur' },
            { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateValid, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          decemberRate: [
            { pattern: /^\d+\.?\d{0,2}$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateRate, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          surplusWay: [
            { required: true, message: '请输入尾款处置计划', trigger: 'blur' },
          ],
        },
        assessPwd: {
          pass: '',
          checkPass: '',
        },
        assessPwdRules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        xnItems: {
          'xn11': { id: '', val: 0, name: '质量认证', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 35, disabled: false, remark: '评分标准第二档的说明：<br/>（1）申报药品获得美国/英国/法国/德国/日本等国家的质量认证机构所做的生物等效性评价认定；<br/>（2）申报药品是我国境内生产、通过并获得美国FDA认证、英国MHRA、德国和法国cGMP认证、日本JGMP证的药品（仅指药物制剂，不包括原料药和车间认证）；<br/>（3）申报药品获得香港医院管理局采购资格（2018 年-2020年）并依此生产。'},
          'xn12': { id: '', val: 0, name: '技术优势', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 20, disabled: false, remark: '（1）指生产企业获得与制剂质量相关的国家级奖项的药品资质证明材料，但不包括获得上述奖项的通用技术或其它通用研究成果而研制的药品。<br/>如获奖者为个人的，仅认可获奖证书排名首位者，且获奖证书上标注的获奖者单位应与生产企业一致。<br/>（2）首仿/首创药品：提供省级及以上药品监督管理局出具的品种首仿（创）的证明，证明中需明确标注有“首仿”或“首创（原研）”。若多家企业<br/>提供同一品种的首创证明（不区别剂型、规格）的，以新药证书颁发时间最早的认定为首仿（创）（申报药品的通用名应与新药证书的药品名称一致）；<br/>均无新药证书的，以药品批件颁发时间为判定依据，颁发时间相同的以编号排名最前的认定为首仿（创）。'},
          'xn13': { id: '', val: 0, name: '经济性', info: '满足任意一项即可得分', score: 5, disabled: true, remark: '无补充说明'},
          'xn14': { id: '', val: 0, name: '原料质量', info: '满足即可得分', score: 5, disabled: true, remark: '申报药品缩使用的原料应具备①美国FDA认证②COS认证③CEP证书，其中之一（以上②和③有DMF/EDMF现场检查报告合格视为符合条件）'},
          // 'xn15': { id: '', val: 0, name: '企业规模', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 20, disabled: false, remark: '内资企业排序以工业企业法人单位为基础，对于以合并报表上报的法人单位，其合并范围内的子公司不再另行参与排序。'},
          'xn16': { id: '', val: 0, name: '企业质量管理', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 5, disabled: false, remark: '（1）申报生产企业建立和完善了其针对产品（药品）、过程或服务的质量体系，并已通过欧、美、日等权威机构的质量认证体系认证，并以此要求执行。<br/>（2）有非欧美日国家进口药是指申报企业可提供向其他国家出口药品的证明，包括认出口货物报关单、出口退税证明和出口国的药品注册证（批件）。'},
          'xn17': { id: '', val: 0, name: '体系认证', info: '满足任意一项即可得分', score: 5, disabled: true, remark: '（1）可提供由中国合格评定国家认可委员会（CNAS）出具的实验室认可证明文件。<br/>（2）可提供企业通过ISO14000环境管理体系认证的证明文件。'},
          // 'xn18': { id: '', val: 0, name: '社会责任', info: '满足任意一项即可得分（点我展开/折叠）', score: 5, disabled: false, remark: '承担国家级、省级医药物资应急生产储备任务的企业，需提供省级或以上卫生健康、财政或工业和信息化等政府管理部门提供的承担医药储备实施工作的证明材料。'},
          'XN': { id: '', val: 0, score: 0, disabled: false},
        },
        znItems: {
          'zn11': { id: '', val: 0, name: '产品质量', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 25, disabled: false, remark: '（1）属于国家一类新药的，应可提供国家药品监督管理总局核发的《新药证书》、生产批件，生产批件注明中药、天然药物注册分类1～6类的品种。<br/>新药证书和生产批件必须直接颁发给该申报药品。<br/>获得国家相关奖项的，是指生产企业获得与制剂质量相关的国家级奖项的药品资质证明材料，但不包括获得上述奖项的通用技术或其它通用研究成果而<br/>研制的药品。如获奖者为个人的，仅认可获奖证书排名首位者，且获奖证书上标注的获奖者单位应与生产企业一致。'},
          'zn12': { id: '', val: 0, name: '产品属性', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 10, disabled: false, remark: '无补充说明'},
          'zn13': { id: '', val: 0, name: '资质认证', info: '满足任意一项即可得分（点我展开/折叠）', score: 5, disabled: false, remark: '（1）申报药品获得美国/英国/法国/德国/日本/加拿大等国家的质量认证机构所做的生物等效性评价认定；<br/>（2）申报药品是我国境内生产、通过并获得美国FDA认证、英国MHRA、德国和法国cGMP认证、日本JGMP认证、<br/>加拿大HPFB认证的药品（仅指药物制剂，不包括原料药和车间认证）；<br/>（3）申报药品获得香港医院管理局采购资格（2018 年-2020年）并依此生产。'},
          'zn14': { id: '', val: 0, name: '安全性', info: '满足即可得分', score: 10, disabled: true, remark: '无补充说明'},
          'zn15': { id: '', val: 0, name: '经济性', info: '满足即可得分（点我展开/折叠）', score: 5, disabled: true, remark: '无补充说明'},
          'zn16': { id: '', val: 0, name: '原料出口', info: '满足即可得分', score: 5, disabled: true, remark: '有原料出口的，应提供相关原料自向相关国家出口的货物报关单、出口退税证明和认证国药品注册证（批件）。'},
          'zn17': { id: '', val: 0, name: '原料质量控制', info: '同一产品按就高原则取一项得分', score: 10, disabled: true, remark: '（1）企业应提供申报药品所用主要原料来自GAP认证生产基地、道地药材生产基地、中成药材溯源种植基地的相关证明材料。<br/>（2）企业应提供申报药品所用主要原料的购销过程清晰、产地明确的相关证明材料。'},
          'zn18': { id: '', val: 0, name: '企业规模', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 20, disabled: false, remark: '内资企业排序以工业企业法人单位为基础，对于以合并报表上报的法人单位，其合并范围内的子公司不再另行参与排序。'},
          'zn19': { id: '', val: 0, name: '企业质量体系', info: '满足任意一项即可得分', score: 5, disabled: true, remark: '（1）可提供由中国合格评定国家认可委员会（CNAS）出具的实验室认可证明文件。<br/>（2）可提供企业通过ISO14000环境管理体系认证的证明文件。'},
          'zn20': { id: '', val: 0, name: '社会责任', info: '同一产品按就高原则取一项得分', score: 5, disabled: false, remark: '承担国家级、省级医药物资应急生产储备任务的企业，需提供省级或以上卫生健康、财政或工业和信息化等政府管理部门提供的承担医药储备实施工作的证明材料。'},
          'ZN': { id: '', val: 0, score: 0, disabled: false},
        },
        product: {
          productId: '', drugInfo: '', code: '', score: 0, blackRecord: '', blackMark: '', remark: '', stype: '',
          xn11: '', xn12: '', xn13: '', xn14: '', xn15: '', xn16: '', xn17: '', xn18: '',
          zn11: '', zn12: '', zn13: '', zn14: '', zn15: '', zn16: '', zn17: '', zn18: '', zn19: '', zn20: '',
          configList: [],
        },
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'getProductOfferPage', status: 3,
        },
        offerform: {
          id: '', attachsName: '', attachsPath: '', disabled: false,
        },
        NXAssessFormVisible: false,
        NZAssessFormVisible: false,
        dialogFormVisible: false,
        dialogVisible: false,
        productRules: {},
        options: [],
        productOfferList: [],
      };
    },
    mounted(){
      // sessionStorage['/mydeclare'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.initView();
      this.captchaUrl = this.getCaptchaUrl();
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.offerUploadUrl = process.env.VUE_APP_API_URL + 'member/o_upload_offer.jspx';
    },
    watch:{
      declareResult: {
        handler(obj){
          //初始赋值
          this.btnActive[3] = false;
          if(obj && obj.expiryDate.time > +new Date()){
            if(0 < obj.goodsNum){
              this.btnActive[3] = true; //选择品种
            }
          }
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
      xnItems: {
        handler(array){
          let _total = 0;
          for(let key in array){
            _total += Number(array[key].val);
          }
          this.product.score = _total; //(0 < _total) ? _total : 0;
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
      znItems: {
        handler(array){
          let _total = 0
          for(let key in array){
            _total += Number(array[key].val);
          }
          this.product.score = _total; //(0 < _total) ? _total : 0;
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
      'product.blackMark': {
        handler(data){
          if('XN' === this.product.stype){
            this.xnItems[this.product.stype].val = data ? -30 : 0;
          }else if('ZN' === this.product.stype){
            this.znItems[this.product.stype].val = data ? -30 : 0;
          }
        }
      }
    },
    methods: {
      selectable(d){
        return !d.checked;
      },
      thousandth(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let str = new String(cellValue).split('.');
          let re = /\d{1,3}(?=(\d{3})+$)/g;
          let n1 = str[0].replace(re, "$&,");
          return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
        };
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      xnSlot(key){
        //console.info(key);
        return this.xnItems[key].remark;
      },
      znSlot(key){
        //console.info(key);
        return this.znItems[key].remark;
      },
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          self.getDeclareResult({ stype: 'DECLARE' }).then(res => {
            self.handleDeclareResult(res, 'DECLARE')
            return self.getDeclareResult({stype: 'OFFER'})
          }).then(res => {
            self.handleDeclareResult(res, 'OFFER')
            let { status, pageNo, pageSize } = this.queryform;
            return self.productOfferPage({ status, pageNo, pageSize })
          }).then(res => {
            self.handleProductOfferPage(res)
            return self.productPage({ status: 5, pageNo: 1, pageSize: 1000 })
          }).then(res => {
            self.handleProductPage(res)
          }).catch(err => {
            console.info(err);
          })
        })
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      handleRadioClick(value, key){
        this.product.configList.forEach(d => {
          if(d.id == value.id){
            let item = this.xnItems[key] || this.znItems[key];
            if(item.id == value.id){
              this.product[key] = '';
              item.val = '';
              item.id = '';
            }else if(!item.val){
              this.product[key] = d.id;
              item.id = d.id;
              item.val = Number(d.svalue);
            }else{
              this.product[key] = d.id;
              item.id = d.id;
              item.val = Number(d.svalue);
            }
          }
        })
        return;
      },
      submitDiscount(d) {
        // d.visible = false;
        //提示用户是否保存
        const id = d.id;
        const userId = d.userId;
        const productId = d.productId;
        let discount = d.discount || '', declarePrice = d.declarePrice || '';
        // if(!discount || !declarePrice){
        //   this.$message({ message: '请先完成价格降幅和议价价格的填报！', offset: 200, type: 'error' });
        //   return;
        // }
        const validateNum = (num) => {
          let reg = /^([0]|([1-9][0-9]*)|(([0]\.\d{1,}|[1-9][0-9]*\.\d{1,})))$/
          if (!reg.test(num)) { return `应大于0！`; }
          reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
          if (!reg.test(num)) {
            return `应保留2位小数！`;
          }
          return false;
        }
        let msg = validateNum(discount);
        if(msg){
          this.$message({ message: `价格降幅${msg}`, offset: 200, type: 'error' });
          return;
        }
        msg = validateNum(declarePrice);
        if(msg){
          this.$message({ message: `议价价格${msg}`, offset: 200, type: 'error' });
          return;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.submitReoffer({ id: id, userId: userId, discount: discount, declarePrice: declarePrice, status: 7 }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: '保存成功！', offset: 200, type: 'success' });
              this.getProductPage();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      getRowKeys(row) {
        return row.id
      },
      handleRadioGroup(val){
        this.product.configList.forEach(d => {
          let key = `${d.stype}${d.skey}`.toLowerCase();
          if(d.id == val){
            if(this.xnItems[key]){
              this.xnItems[key].val = d.svalue;
            }
            if(this.znItems[key]){
              this.znItems[key].val = d.svalue;
            }
            return;
          }
        })
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      getDeclareResult: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.getDeclareResult(param).then(res => {
            this.submitButtonLoading = false;
            if(200 === res.status){
              if(200 === res.data.code){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      getProductPage: function(){
        this.submitButtonLoading = true;
        let{ status, pageNo, pageSize } = this.bargainform
        this.productPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductPage(res)
        })
      },
      productPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productDeclarePage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductPage: function(res){
        this.bargainform.data = [];
        JSON.parse(res.data.data).forEach((d, index, arr) => {
          d.disabled = 'true';
          if(4 === d.status){
            d.statusName = '已失效'
            d.offerPrice = ''
          }else{
            d.statusName = 8 === d.status ? '已中选' : '可报价'
            d.offerPrice = 8 === d.status ? '' : d.winPrice
            d.winPrice = 8 === d.status ? d.winPrice : ''
          }
          if(d.confirmOn){
            d.offerDate = d.confirmOn.time
          }
          d.id = d.declareId
          // d.fn = (null != d.discount && '' != d.discount) ? 'editRow' : 'saveRow'
          // d.operate = (null != d.discount && '' != d.discount) ? '修改' : '保存'
          d.edit = (null != d.discount && '' != d.discount) ? true : false
          this.bargainform.data.push(d);
        });
        this.bargainform.total = res.count;
        this.productOfferList = [...JSON.parse(res.data.data)];
        console.log(this.productOfferList)
      },
      handleDeclareResult: function(res, type){
        if('DECLARE' === type){
          let array = JSON.parse(res.data.data);
          if(0 < array.length){
            this.declareResult = array[0];
            this.fileListOfferFile = [];
            if(!!array[0].attachsPath && !!array[0].attachsName){
              this.offerform.attachsName = array[0].attachsName;
              this.offerform.attachsPath = array[0].attachsPath;
              this.offerform.disabled = true;
              this.fileListOfferFile.push({ name: array[0].attachsName, url: array[0].attachsPath, response: {data: array[0].attachsPath}});
            }
          }
        }else if('OFFER' === type){
          let d = JSON.parse(res.data.data);
            if(0 < d.length){
              if(+new Date() > d[0].effectiveDate.time && +new Date() < d[0].expiryDate.time){
                this.btnActive[4] = false;
                if(this.offerform.disabled){
                  this.btnActive[4] = true;
                }
              }else{
                this.btnActive[4] = true;
                this.offerform.disabled = true;
              }
            }
        }
      },
      getBargainOnlinePage: function(){
        let { stype, pageNo, pageSize } = { ...this.bargainOnlineForm }
        this.bargainOnlineList({ stype, pageNo, pageSize }).then(res => {
          this.handleBargainOnlineList(res.data)
        })
      },
      bargainOnlineList: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.listDeclareResult(param).then(res => {
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBargainOnlineList: function(res){
        this.bargainOnlineForm.data = []
        JSON.parse(res.data).forEach((w, index) => {
          const d = { id: w.id, producerName: w.companyName, goodsNum: w.goodsNum, offerDate: this.toDateString(w.createOn.time, 'yyyy-MM-dd HH:mm'), attachsName: w.attachsName }
          if(w.uploadOn && w.uploadOn.time >= w.createOn.time){
            d.uploadDate = this.toDateString(w.uploadOn.time, 'yyyy-MM-dd HH:mm')
          }
          d.statusName = '未上传'
          d.operate = '上传附件'
          d.fn = 'pdfAttachsUpload'
          if(w.attachsPath){
            d.attachsPath = w.attachsPath
            d.statusName = '已上传'
          }
          this.bargainOnlineForm.data.push(d)
        })
        this.bargainOnlineForm.total = res.count
      },
      getProductOfferPage: function(){
        this.submitButtonLoading = true;
        let { status, pageNo, pageSize } = this.queryform;
        this.productOfferPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductOfferPage(res)
        })
      },
      productOfferPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productPage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductOfferPage: function(res){
        this.queryform.data = [];
        // const data = typeof res.data.data || res.data;
        JSON.parse(res.data.data).forEach((d, index, arr)=>{
          if(this.btnActive[3]){
            if(d.confirmed){
              d.fn = 'getByAssess';
              if(!d.operator || 0 == d.operator){
                d.btnType = 'success';
                d.operate = '填报';
              }else{
                d.btnType = 'primary';
                d.operate = '修改';
              }
            }
          }
          if(!d.operator || 0 == d.operator){
            d.score = '';
          }
          this.queryform.data.push(d);
        });
        this.queryform.total = res.data.count;
      },
      getByAssess(d){
        let param = { productId: this.product.productId, operator: this.operator, status: 3 };
        if(d){
          param.productId = d.id;
          param.operator = 0;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.getByAssess(param).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              if(response.data.data){
                let data = JSON.parse(response.data.data);
                this.goAssess(data);
              }
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'info' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      goAssess(d){
        this.submitButtonLoading = false;
        this.product.drugInfo = `${d.drugTypeFlagZx}质量评价：` + [d.drugName, d.drugDosage, d.packageSpecific, d.code].join('-');
        this.product.productId = d.id;
        this.product.code = d.code;
        this.blackInputVisible = false;
        this.product.blackMark = false;

        this.activeName = '';
        if(d.blackMark){
          this.blackInputVisible = d.blackMark;
          this.product.blackMark = d.blackMark;
          this.activeName = 'blackRecord';
        }
        this.product.blackRecord = d.blackRecord;
        this.product.remark = d.remark;
        this.product.stype = d.drugCode;
        this.product.score = 0;
        if('XN' === d.drugCode){
          for(let key in this.xnItems){
            this.xnItems[key].id = '';
            this.xnItems[key].val = 0;
            this.product[key] = '';
          }
          if(d.blackMark){
            this.xnItems[d.drugCode].val = -30;
          }
          this.NXAssessFormVisible = true;
          this.NZAssessFormVisible = false;
        }else if('ZN' === d.drugCode){
          for(let key in this.znItems){
            this.znItems[key].id = '';
            this.znItems[key].val = 0;
            this.product[key] = '';
          }
          if(d.blackMark){
            this.znItems[d.drugCode].val = -30;
          }
          this.NXAssessFormVisible = false;
          this.NZAssessFormVisible = true;
        }

        this.product.configList = d.configList;
        this.product.configList.forEach((o, index) => {
          let key = (o.stype + o.skey).toLowerCase();
          if(o.configId){
            if(!!this.xnItems[key]){
              this.xnItems[key].id = o.id;
              this.xnItems[key].val = o.svalue;
              this.product[key] = o.configId;
            }
            if(!!this.znItems[key]){
              this.znItems[key].id = o.id;
              this.znItems[key].val = o.svalue;
              this.product[key] = o.configId;
            }
          }
        });
      },
      submitAssessPwd(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            //uJT/Jn4BC9Irrp7D4Jw8MnuB3ZbeNqthJI5FOdk7WIvn7dnSPCkioltDZj3ZnuwaKvgbpx9YZiZymU4lN+Fmf/cVeI3KS2UksHch9R5bzFPmQFJ5Mmcym4ki/NOPcyM4KjRBlm8ZWF6T7GSjDOhnSy9Fwem54GAi85HQ85uF3yQ=
            //因为此处需要前后端统一做base64处理，所以一定要看jsencrypt的源码，检查在encrypt之后是否有base64处理
            let jse = new this.$jsEncrypt();
            // 加入rsa public key
            jse.setPublicKey(`MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDh7DUH66GB326Z0pDzi4pGqAfH60P/gxWMJNugXQt2XlyP9LeApUN/37bIgnx8Rohb0Iw3VdujorfY70rx0XUPo7Y5lNJUEph+N2bVM2deFLPnPAQzAIq0uNhqJgpFwPqZX1BGu7QUvrbqfBzsalbzb9u/PFR9hh9tm0xiT7rlsQIDAQAB`);
            let cendential = this.$md5(this.assessPwd.pass)
            console.info("MD5:", cendential)
            let credential = jse.encrypt(cendential); // 将password加密
            console.info("public key : ", credential)
            this.submitButtonLoading = true;
            this.$api.memberApi.submitAssessPwd({credential: credential}).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.dialogPasswordVisible = false;
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
            return false;
          }
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            let totolscore = this.product.score;
            // if(!totolscore){
            //   this.$message.error(`请完成质量评价后再提交！`);
            //   return;
            // }
            if(-30 > totolscore || 100 < totolscore){
              this.$message.error(`质量评价分应介于-30-100之间！`);
              return;
            }
            let d = this[formName];
            if(d.blackMark && !d.blackRecord){
              this.$message.error(`请说明澄清不良记录！`);
              return;
            }
            let objson = {};
            Object.assign(objson, d);
            objson.ids = [];
            if('ZN' === this.product.stype){
              for(let key in this.znItems){
                if(d[key]){
                  objson.ids.push(d[key]);
                }
                objson[key] = undefined;
              }
            }else if('XN' === this.product.stype){
              for(let key in this.xnItems){
                if(d[key]){
                  objson.ids.push(d[key]);
                }
                objson[key] = undefined;
              }
            }

            objson.drugInfo = undefined;
            objson.configList = undefined;
            this.submitButtonLoading = true;
            this.$api.memberApi.submitAssess(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.dialogFormVisible = false;
                  this.dialogVisible = false;
                  this.$message({ message: '质量评价填报已完成，请关闭本页面，并选择其他您要填报的药品！', offset: 200, type: 'success' });
                  setTimeout(()=>{
                    // this.operator = 1;
                    // this.getByAssess();
                    this.initView();
                  }, 1500)
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
          }
        });
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemoveOfferFile(file, fileList) {
        this.offerform.attachsName = '';
        this.offerform.attachsPath = '';
        this.fileListOfferFile = fileList.slice(0,0);
      },
      handleSuccessOfferAttachs(response, file, fileList) {
        if (response.code === 200) {
          this.bargainStep1.attachsName = file.name;
          this.bargainStep1.attachsPath = response.data;
          this.offerAttachs = fileList;
        } else {
          this.$message.error(response.msg);
          this.offerAttachs = fileList.slice(0,0);
        }
      },
      handleRemoveOfferAttachs(file, fileList) {
        this.bargainStep1.attachsName = '';
        this.bargainStep1.attachsPath = '';
        this.offerAttachs = fileList.slice(0,0);
      },
      beforeOfferFileUpload(file) {
        const supportFileType = ["data"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message({ message: '上传的报价文件格式错误（文件格式应为：' + supportFileType + '）', offset: 200, type: 'error' });
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      handleRemovefddbrsqzsImg(file, fileList) {
        this.form.attachsName = '';
        this.form.attachsPath = '';
        this.fileListfddbrsqzsImg = fileList.slice(0,0);
      },
      handleSuccessfddbrsqzsImg(response, file, fileList) {
        if (response.code === 200) {
          this.form.attachsName = file.name;
          this.form.attachsPath = response.data;
          this.fileListfddbrsqzsImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListfddbrsqzsImg = fileList.slice(0,0);
        }
      },
      handleSuccessOfferFile(response, file, fileList) {
        if (response.code === 200) {
          this.offerform.attachsName = file.name;
          this.offerform.attachsPath = response.data;
          this.fileListOfferFile = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListOfferFile = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        //let fileUrl = process.env.VUE_APP_BASE_URL + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          // this.dialogPdfUrl = pdf.createLoadingTask(fileUrl);
          // this.dialogPdfVisible = true;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["pdf"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      beforeOfferFileUpload(file) {
        const supportFileType = ["data"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message({ message: '上传的报价文件格式错误（文件格式应为：' + supportFileType + '）', offset: 200, type: 'error' });
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      goLogin(msg) {
        this.$message({ message: msg, offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Member/MyDeclare.vue